import { useState } from "react";
import { Button, Card, List } from "antd";
import AddTaskModal from "./components/AddTaskModal";
import Item from "./components/Item";

const Tasks = ({ date, data, refetch }) => {
  const [is_open_add_task_modal, setIsOpenAddTaskModal] = useState(false);

  return (
    <Card
      className="checklist"
      title={`PRIORYTETY ${data?.length > 0 ? `(${data.length})` : ""}`}
      style={{
        marginBottom: 24,
      }}
      styles={{
        header: {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        },
        body: {
          padding: "0 24px",
          maxHeight: 320,
          overflowY: "scroll",
        },
      }}
      extra={
        <Button type="primary" onClick={() => setIsOpenAddTaskModal(true)}>
          Dodaj
        </Button>
      }
    >
      {is_open_add_task_modal && (
        <AddTaskModal
          date={date}
          refetch={refetch}
          handleClose={() => setIsOpenAddTaskModal(false)}
        />
      )}
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => (
          <Item {...item} key={item.id} refetch={refetch} lp={index + 1} />
        )}
      />
    </Card>
  );
};

export default Tasks;
